var lib_core = require("lib-core");
var HeaderRightAngleData = require("./headerRightAngleData.js");

var HeaderRightAngleSocketData = function(position, angle, init) {
    HeaderRightAngleData.apply(this, arguments);
};

lib_core.inherit(HeaderRightAngleSocketData, HeaderRightAngleData);
lib_core.JsonParser.registerClass(HeaderRightAngleSocketData, "HeaderRightAngleSocketData");
module.exports = HeaderRightAngleSocketData;

HeaderRightAngleSocketData.prototype.getSilkscreen = function(pads) {
    if(pads.length === 0) return [];

    var silkscreen = [];
    
    ////////////////////
    //   Pin Marker   //
    ////////////////////
    silkscreen.push(this.getPinOneMarker(pads[0]));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    
    var body = this.getBodyForSilkscreen();
    silkscreen.push(this.getBodyOutline(pads, body));

    return silkscreen;
};